import { Box, Typography } from "@mui/material"

export const missingRecordedValue = "Не записано (null)"

/** JSON values from the captured read model only. No HTML, URL activation or lookup. */
export function RecordedValue({
  value,
  depth = 0,
}: {
  value: unknown
  depth?: number
}) {
  if (value === null) return <>{missingRecordedValue}</>
  if (value === undefined) return <>Поле отсутствует</>
  if (typeof value !== "object")
    return <>{value === "" ? '"" (пустая строка)' : String(value)}</>
  if (depth >= 8) return <RawRecordedJson value={value} />
  if (Array.isArray(value))
    return value.length ? (
      <ol>
        {value.map((item, index) => (
          <li key={index}>
            <RecordedValue value={item} depth={depth + 1} />
          </li>
        ))}
      </ol>
    ) : (
      <>Пустой список []</>
    )
  const entries = Object.entries(value)
  return entries.length ? (
    <Box component="dl" sx={{ m: 0, pl: 2, overflowWrap: "anywhere" }}>
      {entries.map(([key, item]) => (
        <Box key={key}>
          <Typography component="dt" fontWeight="bold">
            {key}
          </Typography>
          <Box component="dd" sx={{ ml: 2 }}>
            <RecordedValue value={item} depth={depth + 1} />
          </Box>
        </Box>
      ))}
    </Box>
  ) : (
    <>Пустой объект {"{}"}</>
  )
}

export function RawRecordedJson({ value }: { value: unknown }) {
  return (
    <Box
      component="pre"
      sx={{ whiteSpace: "pre-wrap", overflowWrap: "anywhere" }}
    >
      {JSON.stringify(value, null, 2)}
    </Box>
  )
}
